export default "__VITE_ASSET__86df5f96__"